import Fingerprint2 from 'fingerprintjs2';
import Cookies from 'js-cookie';
import UUID from './uuid';

export default function initialiseTracking(fingerprintKey, cookieExpires, uuidKey) {
  const lastFingerPrint = Cookies.get(fingerprintKey) || null;

  Fingerprint2.get((browserFingerprint) => {
    if (lastFingerPrint !== browserFingerprint) {
      Cookies.set(fingerprintKey, browserFingerprint, { expires: cookieExpires });
    }
  });

  Cookies.get(uuidKey) || Cookies.set(uuidKey, UUID.generate(), { expires: cookieExpires });
}
